import colors from '@/styles/themes/colors';
import { Image } from '@/types/image.type';

export interface HowWeBuildProduct {
  key: string;
  image: Image;
  title: string;
  link: string;
  linkText: string;
  description: string;
  features: string[];
  color: string;
  bulletColor: 'blue' | 'green' | 'orange' | 'pink';
}

export const howWeBuildProducts: HowWeBuildProduct[] = [
  {
    key: 'discovery',
    image: {
      src: '/images/home/how-we-build-products/discovery.webp',
      alt: 'Discovery',
    },
    title: 'howWeBuildProducts.discovery.title',
    link: '/services/discovery',
    linkText: 'howWeBuildProducts.discovery.subtitle',
    description: 'howWeBuildProducts.discovery.description',
    features: [
      'howWeBuildProducts.discovery.features.0',
      'howWeBuildProducts.discovery.features.1',
      'howWeBuildProducts.discovery.features.2',
    ],
    color: colors.blue500,
    bulletColor: 'blue',
  },
  {
    key: 'design',
    image: {
      src: '/images/home/how-we-build-products/design.webp',
      alt: 'Design',
    },
    title: 'howWeBuildProducts.design.title',
    link: '/services/design',
    linkText: 'howWeBuildProducts.design.subtitle',
    description: 'howWeBuildProducts.design.description',
    features: [
      'howWeBuildProducts.design.features.0',
      'howWeBuildProducts.design.features.1',
      'howWeBuildProducts.design.features.2',
    ],
    color: colors.pink600,
    bulletColor: 'pink',
  },
  {
    key: 'development',
    image: {
      src: '/images/home/how-we-build-products/development.webp',
      alt: 'Development',
    },
    title: 'howWeBuildProducts.development.title',
    link: '/services/development',
    linkText: 'howWeBuildProducts.development.subtitle',
    description: 'howWeBuildProducts.development.description',
    features: [
      'howWeBuildProducts.development.features.0',
      'howWeBuildProducts.development.features.1',
      'howWeBuildProducts.development.features.2',
    ],
    color: colors.green400,
    bulletColor: 'green',
  },
  {
    key: 'delivery',
    image: {
      src: '/images/home/how-we-build-products/delivery.webp',
      alt: 'Delivery',
    },
    title: 'howWeBuildProducts.delivery.title',
    link: '/services/delivery',
    linkText: 'howWeBuildProducts.delivery.subtitle',
    description: 'howWeBuildProducts.delivery.description',
    features: [
      'howWeBuildProducts.delivery.features.0',
      'howWeBuildProducts.delivery.features.1',
      'howWeBuildProducts.delivery.features.2',
    ],
    color: colors.orange500,
    bulletColor: 'orange',
  },
];
